import { render, staticRenderFns } from "./PopupInformative.vue?vue&type=template&id=39d5042d&scoped=true"
import script from "./PopupInformative.vue?vue&type=script&lang=js"
export * from "./PopupInformative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d5042d",
  null
  
)

export default component.exports